import React from 'react';
import { cn } from '@gettactic/helpers/src';

const classes = {
  H1: 'text-[36px] leading-[109%] font-[600] tracking-[0] text-ink',
  H2: 'text-[24px] leading-[109%] font-[600] tracking-[0] text-ink',
  H3: 'text-[18px] leading-[109%] font-[600] tracking-[0] text-ink',
  H4: 'text-[16px] leading-[109%] font-[600] tracking-[0] text-ink',
  H5: 'text-[14px] leading-[109%] font-[600] tracking-[0] text-ink',
  H6: 'text-[12px] leading-[109%] font-[600] tracking-[0] text-ink',
  HeadingCard: 'text-[18px] leading-[109%] font-[600] tracking-[0] text-ink'
};

export interface HeadingProps
  extends React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>> {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'card';
}

const asToClass = {
  h1: classes.H1,
  h2: classes.H2,
  h3: classes.H3,
  h4: classes.H4,
  h5: classes.H5,
  h6: classes.H6,
  card: classes.HeadingCard
};

export const Heading: React.FC<HeadingProps> = ({ as, children, ...rest }) => {
  const className = asToClass[as || 'h1'];

  return (
    <div {...rest} className={cn(className, rest.className)}>
      {children}
    </div>
  );
};
